import { useState, useEffect, useCallback } from 'react';
import { WIX_INSTANCE_PARAMS } from '~actions/component_actions';
import axios from 'axios';
import { Form, Spinner } from 'react-bootstrap';
import styles from 'widget/event_components/ticket-spot.scss';
import promoCodeStyle from './promo-code.scss';
import * as E from './elements';

export const PromoCode = ({ settings, event, cart, handleTicketUpdate, handleInitTicketStateChange, onResizeComponent }) => {
  const keepPromoCodeOpen = settings.get('keepPromoCodeOpen');

  const [value, setValue] = useState();
  const [loading, setLoading] = useState(false);
  const [showInput, setShowInput] = useState(keepPromoCodeOpen);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setShowInput(keepPromoCodeOpen);
    onResizeComponent && onResizeComponent();
  }, [keepPromoCodeOpen]);

  const trackPromoCodeEvent = (eventName, eventData) => {
    if (window.gtag) {
      window.gtag('event', eventName, {
        event_category: 'Promo',
        ...eventData,
      });
    }

    if (window.fbq) {
      window.fbq('trackCustom', eventName, eventData);
    }
  };

  const handlePromo = useCallback(async () => {
    setLoading(true);
    setIsError(false);
    handleInitTicketStateChange();
    try {
      const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${event.get('id')}/promos/apply${WIX_INSTANCE_PARAMS}`;
      const result = await axios.post(url, { code: value, cart }, { withCredentials: true });

      if (!result.data.success) {
        throw new Error(`Invalid promo code`);
      }
      handleTicketUpdate({ promo_code: value });
      trackPromoCodeEvent('ApplyPromoCode', {
        event_label: value,
        currency: event.get('currency'),
        promotion_id: value,
        promotion_name: value,
        content_name: event.get('name'),
        content_category: 'Promo',
        content_ids: [value],
      });
    } catch (e) {
      setIsError(true);
      handleTicketUpdate({ promo_code: null });
      trackPromoCodeEvent('PromoCodeError', {
        event_label: value,
        error_message: e.message || 'Promo code application failed',
        content_name: event.get('name'),
        content_category: 'Promo',
        content_ids: [value],
      });
    }
    setLoading(false);
  }, [value, cart]);

  return (
    <Form.Group controlId="formBasicEmail" className={promoCodeStyle.container}>
      {!keepPromoCodeOpen && (
        <Form.Label
          className="apply-discount-text"
          onClick={() => keepPromoCodeOpen === false && setShowInput(!showInput)}
          style={{ cursor: 'pointer' }}
        >
          {settings.get('applyDiscountText')}
        </Form.Label>
      )}
      <div>
        {showInput && (
          <E.PromoCode>
            {keepPromoCodeOpen && <E.Label className="apply-discount-text">{settings.get('applyDiscountText')}</E.Label>}
            <E.CustomInputGroup>
              <E.StyledFormControl
                className={styles.promoInput}
                onChange={(e) => setValue(e.target.value)}
                disabled={loading}
                placeholder={settings.get('promoCodePlaceholderText')}
              />
              <E.CustomButton variant="text" onClick={handlePromo} disabled={loading} className="promo-apply-button">
                {loading ? <Spinner animation="border" size="sm" /> : 'Apply'}
              </E.CustomButton>
            </E.CustomInputGroup>
          </E.PromoCode>
        )}
      </div>
      {isError && <div className={styles.errorDetails}>Sorry, that code is invalid</div>}
    </Form.Group>
  );
};
